import {BaseCreditCalculator} from "../common/credit/calc.js";

class CRDCalculator extends BaseCreditCalculator {
    code() {return "crd";}
    type() {return "CalcCrd";}

    initialize() {
        this.setupStatistic({
            calcName: 'crd'
        });

        super.initialize();

        // add input fields
        this.addInputField('#credit-sum input', 'creditSum', {
            type: 'money', options: {maxVal: 999999999999.99},
            errors: [{check: function (v) {return !!v;}, selector: '#credit-sum .null-error'}]
        });
    }

    calculate(params) {
        if (params.autoValidation) {
            return false;
        }

        return super.calculate(this.creditSum);
    }
}

$(function () {
    var calc = new CRDCalculator();
});
